module.exports = {"id":-1,"title":"Любая марка","title_uk":"Будь-яка марка"}


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/anyMake.json
// module id = 436
// module chunks = 49